import React, { useState, useEffect } from "react";
import { Card, CardContent } from "semantic-ui-react";
import Tab from "../../components/Tab";
import { Search } from "react-feather";
import Grid from "../../components/Grid";
import Dropdown from "../../components/input/Dropdown";
import {
  getBulkDropdownData,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import Input from "../../components/input/Input";
import SearchDropdown from "../../components/input/SearchDropdown";
import Button from "../../components/input/Button";
import { searchVehicleInOut } from "../../api/VehicleInOutApi";
import LoadingSpinner from "../../components/LoadingSpinner";
import {
  DateCellRenderer,
  ResizableScrollingTextRenderer,
} from "../../components/renderer/StyleRenderer";

function VehicleInAndOut() {
  const [tab, setTab] = useState(1);
  const [activeAccordion, setActiveAccordion] = useState(1);

  const [isLoading, setIsLoading] = useState(false);
  const [resetSearchFields, setResetSearchFields] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);

  const [dateType, setDateType] = useState(1);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [customer, setCustomer] = useState([]);
  const [shipper, setShipper] = useState([]);
  const [status, setStatus] = useState(null);
  const [jobNumbers, setJobNumbers] = useState(null);
  const [requestIds, setRequestIds] = useState(null);
  const [rateType, setRateType] = useState(null);
  const [searchResults, setSearchResults] = useState([]);

  const [dateTypeOptions, setDateTypeOptions] = useState([]);
  const [rateTypeOptions, setRateTypeOptions] = useState([]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      const { date_types: dateTypeData, veh_rate_type: rateTypes } =
        await getBulkDropdownData([
          { key: "date_types" },
          { key: "veh_rate_type" },
        ]);

      setDateTypeOptions(dateTypeData);
      setRateTypeOptions(rateTypes);
      setIsLoading(false);
    })();
  }, []);

  const handleReset = async () => {
    setResetSearchFields(true);
    setSearchClicked(false);
    setDateType(1);
    setFromDate("");
    setToDate("");
    setRateType(null);
    setCustomer([]);
    setShipper([]);
    setJobNumbers("");
    setRequestIds("");
  };

  const handleSearch = async () => {
    setSearchClicked(true);
    setIsLoading(true);
    const payload = {
      dateTypeId: dateType,
      fromDate,
      toDate,
      customerId: customer.length > 0 ? customer[0] : null,
      shipperId: shipper.length > 0 ? shipper[0] : null,
      jobIds: jobNumbers,
      requestIds: requestIds,
    };
    try {
      const response = await searchVehicleInOut(payload);
      console.log("the vehicle in out: ", response);
      setSearchResults(response);
    } catch (e) {
      console.log(e);
      setSearchClicked(false);
      setIsLoading(false);
    }
    console.log("This have been clicked");
    setIsLoading(false);
  };
  const valueFormatter = (params) => {
    const value = params.value;
    return value === null || value === undefined || value === ""
      ? "N/A"
      : value;
  };

  const vehicleInOutColumns = [
    {
      headerName: "Request ID",
      field: "reqCode",
      valueFormatter,
      headerCheckboxSelection: true,
      checkboxSelection: true,
    },
    { headerName: "Job No", field: "jobCode", valueFormatter },
    { headerName: "Vehicle No", field: "vehicle", valueFormatter },
    {
      headerName: "Transporter",
      field: "stkName",
      valueFormatter,
      cellRenderer: ResizableScrollingTextRenderer,
    },
    {
      headerName: "Driver ID",
      field: "driver",
      valueFormatter,
      cellRenderer: ResizableScrollingTextRenderer,
    },
    {
      headerName: "Shipper",
      field: "shipperName",
      cellRenderer: ResizableScrollingTextRenderer,
      valueFormatter,
    },
    {
      headerName: "Customer",
      field: "customerName",
      cellRenderer: ResizableScrollingTextRenderer,
      valueFormatter,
    },
    {
      headerName: "Consignment Type",
      field: "consignmentTypeValue",
      valueFormatter,
    },
    {
      headerName: "Location",
      field: "delivery",
      cellRenderer: ResizableScrollingTextRenderer,
      valueFormatter,
    },
    {
      headerName: "Load Location",
      field: "pickup",
      cellRenderer: ResizableScrollingTextRenderer,
      valueFormatter,
    },
    {
      headerName: "Schedule Date",
      field: "plannedPickupDispatchTime",
      valueFormatter: (params) => {
        const date = new Date(params.value);
        return isNaN(date.getTime())
          ? "N/A"
          : `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
      },
      cellRenderer: DateCellRenderer,
    },
    {
      headerName: "Distributor Code",
      field: "deliveryDistributorCode",
      cellRenderer: ResizableScrollingTextRenderer,
      valueFormatter,
    },
    {
      headerName: "Arrival",
      field: "arrAtPickup",
      valueFormatter: (params) => {
        const date = new Date(params.value);
        return isNaN(date.getTime())
          ? "N/A"
          : `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
      },
      cellRenderer: DateCellRenderer,
    },
    { headerName: "On Time Delivery", field: "ontimeDelivery", valueFormatter },
    {
      headerName: "Departure",
      field: "depFromPickup",
      valueFormatter: (params) => {
        const date = new Date(params.value);
        return isNaN(date.getTime())
          ? "N/A"
          : `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
      },
      cellRenderer: DateCellRenderer,
    },
    { headerName: "Time Gap", field: "fullDurationText" },
    {
      headerName: "Weight/Volume/Pieces",
      field: "weightVolumePieces",
      valueFormatter,
      cellRenderer: ResizableScrollingTextRenderer,
    },
    { headerName: "ETU", field: "etu", valueFormatter },
    { headerName: "ETU KPI", field: "etuKpi", valueFormatter },
    { headerName: "Delivery Ref No", field: "deliveryRefNo", valueFormatter },
    { headerName: "Reference No", field: "jobReference", valueFormatter },
    {
      headerName: "Arrival Time Updated By",
      field: "arrivalTimeUpdatedBy",
      valueFormatter,
      cellRenderer: ResizableScrollingTextRenderer,
    },
    {
      headerName: "Arrival Time Modified Date",
      field: "arrivalTimeUpdate",
      valueFormatter,
      cellRenderer: DateCellRenderer,
    },
    {
      headerName: "Departure Time Updated By",
      field: "departureTimeUpdatedBy",
      valueFormatter,
      cellRenderer: ResizableScrollingTextRenderer,
    },
    {
      headerName: "Departure Time Modified Date",
      field: "departureTimeUpdate",
      valueFormatter,
      cellRenderer: DateCellRenderer,
    },
    {
      headerName: "Current Status",
      field: "statusName",
      valueFormatter,
      cellRenderer: ResizableScrollingTextRenderer,
    },
  ];

  return (
    <>
      <Card style={{ width: "100%" }}>
        <CardContent>
          <div
            className="ui attached tabular"
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div className="ui top attached tabular menu">
              <Tab
                Icon={Search}
                onClick={() => {
                  setTab(1);
                }}
                active={tab === 1}
                label={"Search"}
              />
            </div>
          </div>
          <div
            className="ui bottom attached active tab segment"
            style={{ width: "100%", marginBottom: "10px" }}
          >
            <div className={`title ${activeAccordion === 1 ? "active" : ""}`}>
              <div>
                Search
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className={"drop icon"}></i>
              </div>
            </div>
            <div className={`content ${activeAccordion === 1 ? "active" : ""}`}>
              <form className="ui form">
                <h4 className="ui dividing header">Vehicle In and Out</h4>
                <div
                  className="four fields"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Dropdown
                    required={true}
                    options={dateTypeOptions}
                    label="Date Type"
                    placeholder="Date Type"
                    style={{ height: "20px" }}
                    value={dateType}
                    onChange={(e, data) => {
                      setDateType(data.value);
                    }}
                    clearable={false}
                  />
                  <Input
                    label="From Date"
                    type="date"
                    name="fromDate"
                    value={fromDate}
                    onChange={(e) => {
                      setFromDate(e.target.value);
                    }}
                  />
                  <Input
                    label={"To Date"}
                    type="date"
                    name="toDate"
                    value={toDate}
                    onChange={(e) => {
                      setToDate(e.target.value);
                    }}
                  />
                  <SearchDropdown
                    key={1}
                    editMode={false}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    // occupySpace={false}
                    // multiple={true}
                    // multiValueRemoveHandler={(key) => {
                    //     setCustomer((prev) =>
                    //         prev.filter((item) => item !== parseInt(key)),
                    //     );
                    // }}
                    onResultSelect={(data) =>
                      setCustomer((prev) => [...prev, data])
                    }
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Customer",
                    }}
                    label="Customer"
                  />
                </div>
                <div
                  className="three fields"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <SearchDropdown
                    key={2}
                    editMode={false}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    // occupySpace={false}
                    // multiple={true}
                    // multiValueRemoveHandler={(key) => {
                    //     setShipper((prev) =>
                    //         prev.filter((item) => item !== parseInt(key)),
                    //     );
                    // }}
                    onResultSelect={(data) =>
                      setShipper((prev) => [...prev, data])
                    }
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Shipper",
                      param2: customer.length > 0 ? customer.join(",") : "",
                    }}
                    label="Shipper/Plant"
                  />
                  <Input
                    label="Job Numbers"
                    type="text"
                    name="jobNumbers"
                    value={jobNumbers}
                    onChange={(e) => {
                      setJobNumbers(e.target.value);
                    }}
                  />
                  <Input
                    label="Request Ids"
                    type="text"
                    name="requestids"
                    value={requestIds}
                    onChange={(e) => {
                      setRequestIds(e.target.value);
                    }}
                  />
                  {/*<Dropdown*/}
                  {/*    label="Rate Type"*/}
                  {/*    clearable*/}
                  {/*    placeholder="Select Rate Type"*/}
                  {/*    options={rateTypeOptions}*/}
                  {/*    value={rateType}*/}
                  {/*    onChange={(e, data) => setRateType(data.value)}*/}
                  {/*/>*/}
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button template="search" onClick={handleSearch} />
                    <Button template="searchReset" onClick={handleReset} />
                  </div>
                </div>
              </form>
            </div>
          </div>
          {searchClicked &&
            (isLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                heading="Vehicle In and Out"
                downloadParam={""}
                downloadAction="Vehicle In and Out Excel Download"
                content={searchResults}
                config={vehicleInOutColumns}
                isLoading={isLoading}
                pagination={true}
                multiRowSelection={true}
                showDownloadButton={true}
                downloadOnlySelected={true}
                reportName="vehicle_in_out_report.csv"
              />
            ))}
        </CardContent>
      </Card>
    </>
  );
}

export default VehicleInAndOut;
